import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * Tiny module-level cache for `/auth/shop` to avoid hammering the endpoint
 * across page transitions. Hook returns `null` until the first fetch resolves.
 *
 * Use `refresh()` to force a re-fetch after writing settings.
 */
let _cache = null;
let _pending = null;
const _listeners = new Set();

async function _load(force = false) {
  if (_cache && !force) return _cache;
  if (_pending) return _pending;
  _pending = api.get("/auth/shop").then((r) => {
    _cache = r.data;
    _pending = null;
    _listeners.forEach((cb) => cb(_cache));
    return _cache;
  }).catch((e) => {
    _pending = null;
    throw e;
  });
  return _pending;
}

export function useShopSettings() {
  const [shop, setShop] = useState(_cache);
  useEffect(() => {
    const onChange = (s) => setShop(s);
    _listeners.add(onChange);
    if (!_cache) _load().catch(() => {});
    return () => { _listeners.delete(onChange); };
  }, []);
  return {
    shop,
    refresh: () => _load(true),
    set: (partial) => { _cache = { ..._cache, ...partial }; _listeners.forEach((cb) => cb(_cache)); },
  };
}
